import { render, staticRenderFns } from "./ApplicationFlowIntro.vue?vue&type=template&id=5bed5764&scoped=true&"
import script from "./ApplicationFlowIntro.vue?vue&type=script&lang=js&"
export * from "./ApplicationFlowIntro.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFlowIntro.vue?vue&type=style&index=0&id=5bed5764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed5764",
  null
  
)

export default component.exports